<template>
  <ul 
    v-if="inline"
    class="MenuList MenuList--inline"
  >
    <menu-item-inline
      v-for="(menu, key) in items"
      :color-scheme="colorScheme"
      :description="menu.description"
      :inline="inline"
      :key="key"
      :name="menu.name"
      :title="menu.title"
      :path="menu.path"
      class="MenuList-MenuItem MenuList-MenuItem--inline"
      @link-open="linkOpened(menu.name)"
    />
  </ul>

  <ul 
    v-else
    class="MenuList"
  >
    <menu-item-bullet
      v-for="(menu, key) in items"
      :color-scheme="colorScheme"
      :description="menu.description"
      :inline="inline"
      :key="key"
      :name="menu.name"
      :title="menu.title"
      :path="menu.path"
      :icon="menu.icon"
      class="MenuList-MenuItem"
      @link-open="linkOpened(menu.name)"
    />
  </ul>
</template>

<style lang="scss" scoped>
  @import "~@/styles/_variables.scss";

  .MenuList {
    margin: 0;
    padding: 0;
    list-style-type: none;

    &--inline {
      display: flex;
      justify-content: center;
      flex-wrap: wrap;
    }

    &-MenuItem {
      flex: 0 1 auto;

      &--inline + &--inline:before {
        padding: 0 5px;
        content: "|";
      }

      &--light {
        color: $foreground-light-color;
      }

      &--dark {
        color: black;
      }
    }

    &-MenuLink {
      &--current {
        font-weight: bold;
      }

      &--light {
        color: $foreground-light-color;
      }

      &--dark {
        color: black;
      }
    }
  }
</style>

<script>
  import MenuItemBullet from "@/components/menu/MenuItemBullet";
  import MenuItemInline from "@/components/menu/MenuItemInline";

  export default {
    components: {
      MenuItemBullet,
      MenuItemInline,
    },

    props: {
      inline: {
        type: Boolean,
        default: false,
      },

      items: {
        type: Array,
        required: true,
      },

      colorScheme: {
        type: String,
        default: "light",
        validator: function(value) {
          return ["light", "dark"].indexOf(value) !== -1;
        },
      },
    },

    methods: {
      linkOpened(linkName) {
        this.$emit("link-opened", linkName);
      },

      getMenuItemComponent(inline) {
        return inline ? "MenuItemInline" : "MenuItemBullet";
      },
    },
  };
</script>
